import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, dispatch, change } from 'redux-form';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';
import Button from 'components/atoms/button';
import FormContent from 'components/organisms/formContent';
import FormActions from 'components/molecules/formActions';
import FormCol from 'components/molecules/formCol';
import FormFieldset from 'components/molecules/formFieldset/index.jsx';
import FormTextField from 'components/molecules/formTextField/index.jsx';
import FormCardSelect from 'components/molecules/formCardSelect/index.jsx';
import RadioButtonGroup from 'components/molecules/radioButtonGroup/index.jsx';
import RadioButton from 'components/atoms/radioButton/index.jsx';
import Loader from 'components/atoms/loader';
import WizardProgress from 'components/organisms/wizard/progress';

import validate from '../validate';

class VehicleCharacteristics extends Component {
  getParameter(parameter) {
    if (!this.props.parameters) {
      return [];
    }

    const vehicleParameters = Object.keys(this.props.vehicle[parameter]);
    return this.props.parameters[parameter].filter(parameter => {
      return vehicleParameters.indexOf('' + parameter.id) >= 0;
    });
  }

  getEngines() {
    return this.getParameter('engines');
  }

  getTransmissions() {
    return this.getParameter('transmissions');
  }

  getTractions() {
    return this.getParameter('tractions');
  }

  canContinue() {
    const {
      vehicle,
      engine,
      transmission,
      traction,
      license_plate,
      legacy_service,
      is_under_warranty,
    } = this.props;

    if (hasMany(vehicle.engines) && !engine) {
      return false;
    }

    if (hasMany(vehicle.transmissions) && !transmission) {
      return false;
    }

    if (hasMany(vehicle.tractions) && !traction) {
      return false;
    }

    if (this.props.legacy_service_option && legacy_service === undefined) {
      return false;
    }

    return license_plate && is_under_warranty !== undefined;
  }

  componentDidMount() {
    if (this.props.brand_id === 4) {
      this.props.dispatch(change('shiftRequest', 'is_under_warranty', false));
    }
  }

  render() {
    const { vehicle, handleSubmit, legacy_service_option } = this.props;

    const showModifications = vehicle.name.toLowerCase().includes('amarok');

    const canContinue = this.canContinue();

    return (
      <div className="vehicleSelect">
        <Header inFlow />
        <WizardProgress step="1" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Selecciona tu vehículo</h2>
              <p className="m">Para brindarte un mejor servicio, necesitamos algunos detalles.</p>
              <FormContent nomargins>
                <form onSubmit={handleSubmit}>
                  <FormCol third>
                    <div className="selectedVehicle">
                      <FormCardSelect big>
                        <div>
                          <h4>{vehicle.name}</h4>
                          <img src={vehicle.image} />
                        </div>
                      </FormCardSelect>
                    </div>
                  </FormCol>

                  <FormCol twothird>
                    <FormFieldset first>
                      {!this.props.parameters && <Loader />}

                      {hasMany(vehicle.engines) && (
                        <RadioButtonGroup title="Motor">
                          {this.getEngines().map(engine => {
                            return (
                              <Field
                                key={engine.id}
                                name="engine"
                                component={RadioButton}
                                props={{ fieldValue: engine, inline: true }}
                              >
                                {engine.name}
                              </Field>
                            );
                          })}
                        </RadioButtonGroup>
                      )}

                      {hasMany(vehicle.transmissions) && (
                        <RadioButtonGroup title="Transmisión">
                          {this.getTransmissions().map(transmission => {
                            return (
                              <Field
                                key={transmission.id}
                                name="transmission"
                                component={RadioButton}
                                props={{ fieldValue: transmission, inline: true }}
                              >
                                {transmission.name}
                              </Field>
                            );
                          })}
                        </RadioButtonGroup>
                      )}

                      {hasMany(vehicle.tractions) && (
                        <RadioButtonGroup title="Tracción">
                          {this.getTractions().map(traction => {
                            return (
                              <Field
                                key={traction.id}
                                name="traction"
                                component={RadioButton}
                                props={{ fieldValue: traction, inline: true }}
                              >
                                {traction.name}
                              </Field>
                            );
                          })}
                        </RadioButtonGroup>
                      )}

                      {legacy_service_option && (
                        <RadioButtonGroup title="Mi vehiculo fue entregado">
                          <Field
                            name="legacy_service"
                            component={RadioButton}
                            props={{ fieldValue: true, block: true }}
                          >
                            <strong>Antes</strong> del 31 de diciembre de 2016
                          </Field>
                          <Field
                            name="legacy_service"
                            component={RadioButton}
                            props={{ fieldValue: 0, block: true }}
                          >
                            <strong>Después</strong> del 1 de enero de 2017
                          </Field>
                        </RadioButtonGroup>
                      )}

                      {this.props.brand_id !== 4 && (
                        <RadioButtonGroup title="¿El vehículo esta en garantía?">
                          <Field
                            component={RadioButton}
                            name="is_under_warranty"
                            props={{ fieldValue: true, inline: true }}
                          >
                            Si
                          </Field>
                          <Field
                            component={RadioButton}
                            name="is_under_warranty"
                            props={{ fieldValue: 0, inline: true }}
                          >
                            No
                          </Field>
                        </RadioButtonGroup>
                      )}

                      <Field
                        component={FormTextField}
                        name="license_plate"
                        label="Dominio"
                        type="text"
                        size="s"
                      />

                      <Field
                        component={FormTextField}
                        name="chassis"
                        label="Número de chasis"
                        type="text"
                        size="b"
                        helpText="Puedes encontrar este número en la tarjeta verde. Si no completás el chasis recordá traer contigo la tarjeta verde al momento del turno."
                      />

                      <Field
                        component={FormTextField}
                        name="estimated_kms"
                        label="Kilometraje aproximado"
                        type="text"
                        size="b"
                        helpText="Kilometraje aproximado del vehículo, no tiene que ser exacto."
                      />

                      {showModifications && (
                        <RadioButtonGroup title="¿El vehículo tiene alguna modificación sobre el equipamiento de fabrica?">
                          <Field
                            component={RadioButton}
                            name="has_modifications"
                            props={{ fieldValue: true, inline: true }}
                          >
                            Si
                          </Field>
                          <Field
                            component={RadioButton}
                            name="has_modifications"
                            props={{ fieldValue: 0, inline: true }}
                          >
                            No
                          </Field>
                        </RadioButtonGroup>
                      )}
                    </FormFieldset>
                  </FormCol>

                  <FormActions back={this.props.previousPage}>
                    <Button type="submit" buttonText="Continuar" disabled={!canContinue} />
                  </FormActions>
                </form>
              </FormContent>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

function hasMany(object) {
  return Object.keys(object).length > 1;
}

VehicleCharacteristics = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(VehicleCharacteristics);

const selector = formValueSelector('shiftRequest');

VehicleCharacteristics = connect(state => {
  return {
    vehicle: selector(state, 'vehicle'),
    engine: selector(state, 'engine'),
    transmission: selector(state, 'transmission'),
    traction: selector(state, 'traction'),
    license_plate: selector(state, 'license_plate'),
    is_under_warranty: selector(state, 'is_under_warranty'),
    legacy_service: selector(state, 'legacy_service'),
    has_modifications: selector(state, 'has_modifications'),
    legacy_service_option: state.configuration.legacy_service_option,
    brand_id: state.configuration.brand_id,
  };
})(VehicleCharacteristics);

export default VehicleCharacteristics;
